// extracted by mini-css-extract-plugin
export default {"dateInput":"StatisticsPage_dateInput__pFgcZ"};